<script>
	import ButtonInput from '../atoms/ButtonInput.svelte';
	import ButtonLink from '../atoms/ButtonLink.svelte';
	import TitlePortfolio from '../atoms/TitlePortfolio.svelte';
	import Media from './Media.svelte';
	import { SendDataToPhp } from '../service';
	import { getPhpFolderPath, getConnectorValue } from '../query';
	import AlternateButton from './AlternateButton.svelte';
	import MediaForm from './MediaForm.svelte';

	export let maxValue;
	export let media;
	let newPos = media.position;
	let isConnected = getConnectorValue();

	function deletePortfolio() {
		SendDataToPhp(getPhpFolderPath() + 'delElem.php', 'pos=' + media.position + '&table=portfolio', 'protfolio');
	}

	function up() {
		SendDataToPhp(getPhpFolderPath() + 'up.php', 'table=portfolio&id=' + media.id + '&pos=' + media.position, 'protfolio');
	}
	function down() {
		SendDataToPhp(getPhpFolderPath() + 'down.php', 'table=portfolio&id=' + media.id + '&pos=' + media.position, 'protfolio');
	}

	function changePos() {
		SendDataToPhp(
			getPhpFolderPath() + 'ChangePos.php',
			'table=portfolio&initPos=' + media.position + '&id=' + media.id + '&pos=' + newPos,
			'protfolio'
		);
	}
</script>

<TitlePortfolio title={media.nom} />
<section>
	{#if isConnected}
		<div>
			<div>
				<AlternateButton condition={media.position != 1} onClick={up} value="Up" />
				<AlternateButton condition={media.position != maxValue} onClick={down} value="Down" />
			</div>
			<!--<MediaForm onClick={changePos} bind:positionValue={newPos} maxValue={maxValue} />-->
			<ButtonInput value="Supprimer" onClick={deletePortfolio} />
		</div>
	{/if}

	{#if media.media.length > 0}
		<Media {media} maxValue={-1} route="portefolio/{media.id}" />
	{:else}
		<div class="link">
			<ButtonLink route="portefolio/{media.id}" text="Ajouter des photos !" />
		</div>
	{/if}
</section>

<style>
	section {
		display: flex;
		justify-content: center;
		min-height: 100px;
	}

	section > div {
		display: flex;
		width: 74%;
		justify-content: space-between;
		padding: 0% 0.5%;
		background-color: rgba(157, 138, 186, 0.5);
		position: absolute;
	}

	.link {
		background-color: inherit;
		margin-top: 50px;
		justify-content: center;
	}
</style>
